/**
 * Währungs-Formatierung (EUR, de-DE) — eine Quelle im Frontend.
 * DECIMAL-Beträge kommen vom API als String; niemals Rechnungen mit
 * den Strings machen, nur formatieren.
 */
export function formatCurrency(value: string | number | null | undefined): string {
  const n = typeof value === 'string' ? parseFloat(value) : value;
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(n);
}

/** Prozent-Formatierung (de-DE, ohne Dezimalstellen-Fuzz) — z. B. MwSt-Satz "19 %". */
export function formatPercent(value: string | number | null | undefined): string {
  const n = typeof value === 'string' ? parseFloat(value) : value;
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  return `${new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(n)} %`;
}

/** Kurzes Datumsformat für DateTime-Strings (YYYY-MM-DD HH:MM:SS → dd.MM.yyyy HH:MM). */
export function formatDateTime(value?: string | null): string {
  if (!value) return '';
  const m = value.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
  if (!m) return value;
  return `${m[3]}.${m[2]}.${m[1]} ${m[4]}:${m[5]}`;
}